module.exports = __webpack_public_path__ + "static/media/Gail Siminovsky Headshot.0637a1db.jpeg";